import { Button, Tooltip } from 'antd';
import { useSankey } from '../../../contexts/SankeyContext';
import { ReactComponent as SankeyIcon } from '../../../assets/icons/sankey.svg';
import './styles.css';

const SankeyButton = () => {
  const { openSankey } = useSankey();

  return (
    <div title="Sankey diagram"  placement="bottom">
      <Button
        type="primary"
        icon={<SankeyIcon />}
        onClick={openSankey}
        className="sankey-open-btn"
        shape="circle"
      />
    </div>
  );
};

export default SankeyButton;
